var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMainFill14 = function SvgMainFill14(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078FF",
    fillRule: "evenodd",
    d: "M10.013 3.889 6.151 8.365l-2.262-2.08-.778.937 3.12 2.87.015.012.008.007.348-.42 4.287-4.967zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0",
    clipRule: "evenodd"
  })));
};
export default SvgMainFill14;